export function dataURIToFile(dataURI: string): File | undefined {
    const parts = dataURI.split(/[:;,]/);

    if (parts.length !== 4 || parts[0] !== "data" || parts[1] !== "image/png" || parts[2] !== "base64") return;

    const mimeString = parts[1];
    const byteString = atob(parts[3]);

    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([intArray], { type: mimeString });

    // NOTE: The "signature" filename will be overwritten with a generated id when uploaded via `uploadAppFile`
    return new File([blob], "signature", { type: blob.type });
}
